import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuIdService } from 'src/app/core/services/menu-id.service';
import { NotificationComponent } from '../notification/notification.component';
import { AuthService } from 'src/app/core/services/auth.service';
import { TokenStorageService } from 'src/app/core/services/token-storage.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  modules: any[] = [];
  menuToView: any[] = [];
  userDetail: any;

  constructor(
    public menuIdService: MenuIdService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    public tokenStorageService: TokenStorageService,
    private router: Router,
    private restService: RestService, 
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
  ) { 
    if(this.tokenStorageService.isAuthenticated()){
      this.getMenuData();
    }
  }

  ngOnInit(): void {
   
  }
  
  logout() {
    const dialogRef = this.dialog.open(NotificationComponent, {
      disableClose: true,
      panelClass: 'dialog-class',
      data: {
        block: 'yesOrNo',
        message: this.translate.instant('Logout_Msg')
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.authService.logoutUser();
        this.router.navigate(['/quotation/get-quote']);
      }
    });
  }

  logIn() {
    this.router.navigate(['/auth/login']);
  }

  getMenuData() {
    this.loader.show();
    this.restService.postDataDs(null, 'api/digital/core/Module/FetchAllModulesforLogedinRole').subscribe(
      {
        next: (data) => {
          try {
          if (data.rcode === 200) {
            this.modules = data.rObj.modulesforRole;
            if (this.modules?.length > 0) {
              //this.menuToView = this.modules;
              // this.menuToView = this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === null && module.url === null);
              // Assuming 'menuToView' is your array of main modules
              const menuToView = this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === null && module.url === null);

              // Function to get sub-modules for a given main module
              const getSubModules = (mainModule: any) =>
                this.modules.filter((module: any) => !module.isFunctionality && module.parentModuleID === mainModule.sWAModuleID && module.url === null);

              // Function to get direct functionality modules for a given main module
              const getDirectFunctionalityModules = (mainModule: any) =>
                this.modules.filter((module: any) => module.isFunctionality && module.parentModuleID === mainModule.sWAModuleID && module.url !== null);

              // Function to get functionality items for a given submodule
              const getFunctionalityItems = (subModule: any) =>
                this.modules.filter((module: any) => module.isFunctionality && module.parentModuleID === subModule.sWAModuleID && module.url !== null);

              // Map main modules and add sub-modules, direct functionality modules, and functionality items
              const hierarchicalModules = menuToView.map(mainModule => ({
                ...mainModule,
                subModules: getSubModules(mainModule).map(subModule => ({
                  ...subModule,
                  functionalityItems: getFunctionalityItems(subModule)
                })),
                activeModules: getDirectFunctionalityModules(mainModule)
              }));

              // Use the 'hierarchicalModules' array based on your specific requirements
              this.menuToView = hierarchicalModules;
            }
            this.userDetail = data.rObj.userDetails;
          } else {
            this.errorHandler.handleRcodeError(data);
          }
          } catch (error) {
            this.errorHandler.internalError();
          } finally{
            this.loader.hide();
          }
        },
        error: (error) => {
          this.errorHandler.handleStatusError(error);
        }
      }
    );
  }
}
